import {createRouter, createWebHistory} from 'vue-router'

const Login = () => import('@/view/account/login.vue')
const Pay = () => import('@/view/pay/Pay.vue')
const PayForm = () => import('@/view/pay/PayForm.vue')

const Dashboard = () => import('../view/Dashboard.vue')
const Profile = () => import('@/view/Profile.vue')
const TransactionList = () => import('@/view/transaction/TransactionList.vue')

const PaySystemList = () => import('@/view/paysystem/PaySystemList.vue')
const PaySystemAdd = () => import('@/view/paysystem/PaySystemAdd.vue')
const PaySystemUpd = () => import('@/view/paysystem/PaySystemUpd.vue')
const PaySystemGet = () => import('@/view/paysystem/PaySystemGet.vue')

const KktList = () => import('@/view/kkt/KktList.vue')
const KktAdd = () => import('@/view/kkt/KktAdd.vue')
const KktGet = () => import('@/view/kkt/KktGet.vue')
const KktUpd = () => import('@/view/kkt/KktUpd.vue')

const CompanyList = () => import('@/view/company/CompanyList.vue')
const CompanyAdd = () => import('@/view/company/CompanyAdd.vue')
const CompanyGet = () => import('@/view/company/CompanyGet.vue')
const CompanyUpd = () => import('@/view/company/CompanyUpd.vue')
const CompanyUserList = () => import('@/view/company/CompanyUserList.vue')
const CompanyUserAdd = () => import('@/view/company/CompanyUserAdd.vue')
const CompanyUserUpd = () => import('@/view/company/CompanyUserUpd.vue')
const CompanyTransactionList = () => import('@/view/company/CompanyTransactionList.vue')
const ErrorPage404 = () => import('@/view/error/ErrorPage404.vue')

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {guest: true}
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {requiresAuth: true}
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {requiresAuth: true}
    },
    {
        path: '/transactions',
        children: [
            {
                path: '',
                name: 'TransactionList',
                component: TransactionList,
                meta: {requiresAuth: true}
            }
        ]
    },
    {
        path: '/ps',
        children: [
            {
                path: '',
                name: 'PaySystemList',
                component: PaySystemList,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
            {
                path: 'add/:method',
                name: 'PaySystemAdd',
                component: PaySystemAdd,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
            {
                path: 'get/:id',
                name: 'PaySystemGet',
                component: PaySystemGet,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
            {
                path: 'upd/:id',
                name: 'PaySystemUpd',
                component: PaySystemUpd,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
        ]
    },
    {
        path: '/kkt',
        children: [
            {
                path: '',
                name: 'KktList',
                component: KktList,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
            {
                path: 'add/:type',
                name: 'KktAdd',
                component: KktAdd,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
            {
                path: 'get/:id',
                name: 'KktGet',
                component: KktGet,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            },
            {
                path: 'upd/:id',
                name: 'KktUpd',
                component: KktUpd,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN', 'ROLE_MERCHANT']}
            }
        ]
    },
    {
        path: '/company',
        children: [
            {
                path: '',
                name: 'CompanyList',
                component: CompanyList,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
            },
            {
                path: 'add',
                name: 'CompanyAdd',
                component: CompanyAdd,
                meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
            },
            {
                path: ':id',
                children: [
                    {
                        path: '',
                        name: 'CompanyGet',
                        component: CompanyGet,
                        meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
                    },
                    {
                        path: 'upd',
                        name: 'CompanyUpd',
                        component: CompanyUpd,
                        meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
                    },
                    {
                        path: 'user',
                        children: [
                            {
                                path: 'list',
                                name: 'CompanyUserList',
                                component: CompanyUserList,
                                meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
                            },
                            {
                                path: 'add',
                                name: 'CompanyUserAdd',
                                component: CompanyUserAdd,
                                meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
                            },
                            {
                                path: 'upd/:user_id',
                                name: 'CompanyUserUpd',
                                component: CompanyUserUpd,
                                meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
                            }
                        ]
                    },
                    {
                        path: 'transactions',
                        children: [
                            {
                                path: '',
                                name: 'CompanyTransactionList',
                                component: CompanyTransactionList,
                                meta: {requiresAuth: true, roles: ['ROLE_ADMIN']}
                            }
                        ]
                    }

                ]
            }
        ]
    },
    {
        path: '/pay',
        children: [
            {
                path: '',
                name: 'PayForm',
                component: PayForm
            } ,
            {
                path: ':hash',
                name: 'Pay',
                component: Pay
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: ErrorPage404
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Прокрутка к началу страницы при навигации
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

// Navigation guard для защиты роутов
router.beforeEach(async (to, from, next) => {
    try {
        const Session = await import('@/utils/Session')
        const credential = await Session.getSessionWithCrypto(Session.sessionName.CREDENTIAL)
        const currentUser = await Session.getSessionWithCrypto(Session.sessionName.CURRENT_USER)

        const isAuthenticated = !!credential
        const userRole = currentUser?.role

        // Если маршрут требует авторизации
        if (to.meta.requiresAuth) {
            if (!isAuthenticated) {
                // Сохраняем текущий URL для редиректа после логина
                return next({ name: 'Login', query: { redirect: to.fullPath } })
            }

            // Если указаны требуемые роли, проверяем
            if (to.meta.roles && Array.isArray(to.meta.roles)) {
                if (!userRole || !to.meta.roles.includes(userRole)) {
                    // Доступ запрещён — перенаправляем на dashboard
                    return next({ name: 'Dashboard' })
                }
            }
        }

        // Если пользователь авторизован и пытается зайти на страницу логина
        if (to.meta.guest && isAuthenticated) {
            return next({ name: 'Dashboard' })
        }

        next()
    } catch (error) {
        console.error('Router guard error:', error)
        next()
    }
})

//router.afterEach(() => {
//    // Скрываем лоадер после завершения навигации
//    setTimeout(() => {
//        store.dispatch('globalLoader/hide').then()
//    }, 200)  // Небольшая задержка для плавности
//})

export default router